export const urlList = {
  language: {
    getLanguagePack: '../../assets/languagePacks/',
  },
  getTransactions: {
    getTransferType: 'assets/data/transfertypes.json',
    getTransactionType: 'assets/data/transactiontypes.json',
  },
};
